var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#4F74F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 25.75,
    width: 8.5,
    height: 8.5,
    stroke: "#F2F5FF",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 18H18V25H19.5V19.5H25V18Z",
    fill: "#F2F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42H18V35H19.5V40.5H25V42Z",
    fill: "#F2F5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 25L42 18L35 18L35 19.5L40.5 19.5L40.5 25L42 25Z",
    fill: "#F2F5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35L42 42L35 42L35 40.5L40.5 40.5L40.5 35L42 35Z",
    fill: "#F2F5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrDownload);
export default __webpack_public_path__ + "static/media/qr_download.519000f32b69f523f7b84b1a3f59731e.svg";
export { ForwardRef as ReactComponent };